import { EmailMarketingProvider, TenantCredentialType } from "generated/graphql";
import React from "react";
import { AudienceManager, AudienceManagerConfig } from "../audience/audience-manager";

interface MailchimpProps {
    match?: {
        path?: string;
        params?: {
            audienceId?: string;
            subtab?: string;
            audienceTab?: string;
        };
    };
}

const mailchimpConfig: AudienceManagerConfig = {
    providerName: "Mailchimp",
    credentialType: TenantCredentialType.Mailchimp,
    redirectPath: "/settings/integrations/mailchimp",
    authUri: "/api/auth/mailchimp",
    provider: EmailMarketingProvider.Mailchimp,
};

export const Mailchimp: React.FC<MailchimpProps> = props => {
    return <AudienceManager config={mailchimpConfig} match={props.match} />;
};
